import { DefaultRootState } from "stores";
import { AppChatState } from "./slice";

export const getAppChatState = <T extends keyof AppChatState>(
  state: DefaultRootState,
  name: T
): AppChatState[T] => {
  return state.app.chat[name];
};
